module.exports = __webpack_public_path__ + "static/media/PROD_JW4.9bb3e563.png";